import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { constant } from '../../app.constants';
import { ValidateTokenJwtResponse } from '../external-authentication/external-authentication.model';

// declare const firebase: any;
@Injectable()
export class AuthenticationService extends ParentService {
  public token: string;
  private readonly storageKey = 'currentUser';

    /**
     *
     * @param {Http} http
     * @param {Router} router
     */
  constructor(private http: Http, private router: Router) {
    super();
    }

    login(data: any): Observable<boolean> {
        const bodyString = JSON.stringify(data);
        const headers = new Headers({
          'Content-Type': 'application/json',
          'Version': this.localVersion
        });
        const options = new RequestOptions({ headers: headers });
        return this.http.post(constant.URL_SESSION, bodyString, options)
            .map((response: Response) => {
                    const body = (response.json && response.json()) || {};
                    const token = body.token;
                    const userprofileid = body.userprofileid;
                    const tenant = body.tenant;
                    const localVersion = body.localversion;
                    if (token) {
                        this.token = token;
                        this.saveCurrentUser(data.username, token, userprofileid, tenant, localVersion);
                        return true;
                    }
                    return false;
                }
            )
            .catch((error: any) => Observable.throw(error.json()));
    }

  private saveCurrentUser(
    username: string,
    token: string,
    userprofileid: any,
    tenant: any,
    localversion: any
  ): void {
    const value = {
      username: username,
      token: token,
      userprofileid: userprofileid,
      tenant: tenant,
      localversion: localversion,
    };
    localStorage.setItem(this.storageKey, JSON.stringify(value));
  }

    // TODO - implementar este método
    // logInFirebase(email: string, password: string) {
    //     return new Promise((resolve, reject) => {
    //       firebase.auth().signInWithEmailAndPassword(email, password)
    //           .then(user =>  resolve(user))
    //           .catch(error => reject(error));
    //   });
    // }

    // logoutFirebase() {
    //     return new Promise<void>((resolve, reject) => {
    //       firebase.auth().signOut()
    //           .then(() => resolve())
    //           .catch(error => reject(error));
    //   });
    // }

    /**
     *
     * @returns {Observable<any>}
     */
    logout() {
        // Clear token remove user from local storage to log user out
            return this.http.delete(constant.URL_SESSION, this.headerPost())
            .map((response: Response ) => {
                    response.json();
                }
            ).catch((error: any) => Observable.throw(error.json()));
    }

    /**
     *
     * @param email
     * @returns {Observable<any>}
     */
    rememberPassword(email) {
        const data = {
            EmailAddress: email
        };
        const string  = JSON.stringify(data);
        const headers = new Headers({ 'Content-Type': 'application/json', 'Version': this.localVersion });
        const options = new RequestOptions({ headers: headers });
        return this.http.put(constant.URL_REMEMBER_PASSWORD, string, options )
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    hasIntegration(email: string): Observable<boolean> {
      const url = constant.URL_MICROSOFT_HAS_INTEGRATION + '?email=' + encodeURIComponent(email.trim());
      return this.http
        .get(url, this.getHeader())
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

    validatetoken(data: { token: string }): Observable<ValidateTokenJwtResponse> {
      const url = constant.URL_GET_URL_VALIDATE_TOKEN;
      return this.http
        .post(url, data, this.headerPost())
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/authentication.service.ts